import {AbstractRepository} from "../repository";

export type FlowFile = {
  id: string
  name: string
  type: string
  created_at: string
  updated_at: string
}

export type Flow = {
  id: string
  name: string
  enabled: boolean
  trigger: FlowTrigger
  conditions: FlowCondition[]
  actions: FlowAction[]
  schedules?: FlowSchedule[]
  created_at: string
  updated_at: string
}

export type FlowTrigger = ContractStartFlowTrigger | CalendarWeekFlowTrigger
export type ContractStartFlowTrigger = {
  type: "contract_start"
  params: { days_offset: number|null }
}
export type CalendarWeekFlowTrigger = {
  type: "calendar_week"
  params: { week_number: number|null }
}

export type FlowCondition = {
  field: string
  operator: 'eq'|'gt'|'gte'|'lt'|'lte'|'dc'
  value: string|number|boolean
}

export type FlowAction = AssignLearnModuleAction | SendWelcomeMailAction | SendMailAction
export type SendWelcomeMailAction = {
  type: 'send_welcome_email'
  params: {}
}
export type AssignLearnModuleAction = {
  type: 'assign_learn_module'
  params: {
    learn_module_id: string
  }
}
export type SendMailAction = {
  type: 'send_welcome_email'
  params: {
    subject: string
    body: string
    attachments: string[] // Flow attachments
  }
}

export type FlowSchedule = {
  id: string
  flow_id: string
  keycloak_sub: string
  scheduled_at: string
  executed_at: string|null
  finished_at: string|null
  created_at: string
  updated_at: string
}

export default class FlowsRepository extends AbstractRepository {
  public async listFlows(): Promise<Array<Flow>> {
    let response = await this.request<{ data: { [id: number]: Flow } }>('GET', 'flows');
    return this.unpackDataCollectionResponse(response);
  }
  public async getFlow(flowId: string): Promise<Flow> {
    let response = await this.request<{ data: Flow }>('GET', `flows/${flowId}`);
    return response.data;
  }
  public async addFlow(name: string, triggerType: string, triggerParams: object): Promise<void> {
    await this.request('POST', 'flows', {
      name,
      enabled: false,
      trigger_type: triggerType,
      trigger_params: triggerParams,
    });
  }
  public async updateFlowFields(flowId: string, name: string, enabled: boolean): Promise<void> {
    await this.request('PATCH', `flows/${flowId}`, {
      name,
      enabled,
    });
  }
  public async updateFlowLogic(flowId: string, trigger: FlowTrigger, conditions: FlowCondition[], actions: FlowAction[]): Promise<void> {
    await this.request('PATCH', `flows/${flowId}`, {
      trigger,
      conditions,
      actions,
    });
  }

  public async listFlowFiles(): Promise<Array<FlowFile>> {
    let response = await this.request<{ data: { [id: number]: FlowFile } }>('GET', 'flows/files');
    return this.unpackDataCollectionResponse(response);
  }

  public async deleteFlowSchedules(flowId: string): Promise<void> {
    await this.request<{ data: Flow }>('DELETE', `flows/${flowId}/remove-planned`)
  }

}
